import axios from 'axios'

import * as types from '../mutation-types'

import store from '../index'

//
export const state = {

	paciente : {},

	pacientes: []

}

//
export const getters = {
	paciente : state => state.paciente
}

//
export const actions = {

	 // requer id do paciente
	 async getPacienteId( { commit, dispatch } , id){
		 commit(types.SET_PACIENTE, { paciente: {} })
			try {
					const { data } = await axios.get(`/api/pacientes-json/${id}`)
					if (data.id) {
						commit(types.SET_PACIENTE, { paciente: data })
					}else {
						dispatch('alert/erroAoCarregar', 'o Paciente' ,{ root: true })
					}
	  	} catch (e) {
					dispatch('alert/erroAoCarregar', 'o Paciente' ,{ root: true })
	  	}
	 },

	 async getPacientes( { commit, dispatch }){

			try {
					const { data } = await axios.get('/api/pacientes-json')
					commit(types.SET_PACIENTES, { pacientes: data })
	  	} catch (e) {
					dispatch('alert/erroAoCarregar', null ,{ root: true })
	  	}
	 },


	 // atualizar no banco de dados e na state
	 async updateApiPaciente({ dispatch, commit,  rootState } , paciente){

			try {
					let id = paciente.id
					await axios.put(`/api/pacientes-json/${id}`, paciente)
					// assim que acessa informações dos modulos
					let termo = rootState.config.user_config.termo_paciente.sing
					//assim que utiliza action de outros modulos
					dispatch('alert/salvoComSucesso', termo , {root: true})

					dispatch('getPacienteId', paciente.id)

			} catch (e) {
					dispatch('alert/erroAoSalvar', null, { root: true })
			}
		},

		 // limpar paciente da state
		clearPaciente( { commit } ) {
			 commit(types.SET_PACIENTE, { paciente: {} })
		},

		// atualizar paciente apenas no state
		setPaciente( { commit }, paciente ) {
			 commit(types.SET_PACIENTE,  paciente )
		}

}


//
export const mutations = {

	[types.SET_PACIENTE] ( state, { paciente })	{
		state.paciente = paciente
	},

	[types.SET_PACIENTES] ( state, { pacientes }){
		state.pacientes = pacientes
	}

}






//



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/paciente.js